function _legend() { 
  let field = this.__execs__.field;
  if (this.mono() && (!field.region || this.isFacet())) { //mono 이면서 dimensions 1개인 경우 축 필요 없음
    return; 
  }
  this.renderLegend('x');
}

export default _legend;


// WEBPACK FOOTER //
// ./layouts/bar/_legend.js